import { defineStore } from 'pinia'

interface Team {
  id: string
  metadata?: {
    name: string
    [key: string]: any
  }
  [key: string]: any
}


export const useUserStore = defineStore(
  "UserStore",
  () => {
    const roles = ref(["admin", "basic", "partner"]);
    const role = ref("");
    const teams = ref<Team[]>([]);
    const receiveNewsletter = ref(true);
    const selectedTeam = ref<Team>({} as Team);
    const subscriptionStatus = ref('');
    const plan = ref<Record<string, any> | null>(null);
    const user = ref({});
    const searchToken = ref('');
    const planDataFetched = ref(false);
    const credits = ref(0);
    const balance = ref(0);
    const currency = ref('usd');
    const grants = ref<any[]>([]);
    const transactions = ref<any[]>([]);

    const setRole = (new_role: string) => {
      role.value = new_role;
    };

    const setTeams = (new_teams: Team[]) => {
      teams.value = new_teams;
    };

    const setSelectedTeam = (new_team: Team) => {
      selectedTeam.value = new_team;
      searchToken.value = new_team?.metadata?.meilisearch_token || '';
    };

    const setReceiveNewsletter = (status: boolean) => {
      receiveNewsletter.value = status;
    };
      
    const setSubscriptionStatus = (status: string) => {
      subscriptionStatus.value = status;
    };

    const setPlan = (new_plan: Record<string, any>) => {
      plan.value = plan.value ? { ...plan.value, ...new_plan } : new_plan;
      planDataFetched.value = true;
    };

    const setUser = (new_user: object) => {
      user.value = new_user
    }

    const setSearchToken = (token: string) => {
      searchToken.value = token;
    }

    const setCredits = (creditsAmount: number) => {
      credits.value = creditsAmount;
    };

    const setBalance = (balanceAmount: number) => {
      balance.value = balanceAmount;
    };

    const setCurrency = (currencyCode: string) => {
      currency.value = currencyCode;
    };

    const setGrants = (grantsData: any[]) => {
      grants.value = grantsData;
    };

    const setTransactions = (transactionsData: any[]) => {
      transactions.value = transactionsData;
    };

    const fetchUserPlan = async () => {
      if (planDataFetched.value) return plan.value;
      
      try {
        const planData = await $fetch('/api/users/plan', {
          method: 'POST',
          credentials: 'omit',
        });
        
        if (planData) {
          setPlan(planData);
          return planData;
        }
      } catch (error) {
        console.error('Error fetching user plan:', error);
      }
      
      return plan.value;
    };

    const refreshUserPlan = async () => {
      try {
        console.log('🔄 Refreshing user plan...');
        const planData = await $fetch('/api/users/plan', {
          method: 'POST'
        });
        
        if (planData) {
          setPlan(planData);
          console.log('✅ User plan refreshed:', planData);
          return planData;
        }
      } catch (error) {
        console.error('Error refreshing user plan:', error);
      }
      
      return plan.value;
    };

    const invalidatePlanCache = () => {
      planDataFetched.value = false;
      plan.value = null;
      console.log('🗑️ Plan cache invalidated');
    };

    return {
      roles,
      role,
      setRole,
      teams,
      setTeams,
      selectedTeam,
      setSelectedTeam,
      receiveNewsletter,
      setReceiveNewsletter,
      setSubscriptionStatus,
      subscriptionStatus,
      plan,
      setPlan,
      setUser,
      user,
      searchToken,
      setSearchToken,
      planDataFetched,
      fetchUserPlan,
      refreshUserPlan,
      invalidatePlanCache,
      credits,
      balance,
      currency,
      grants,
      transactions,
      setCredits,
      setBalance,
      setCurrency,
      setGrants,
      setTransactions
    };
  },
  {
    persist: true
  }
);
